import { CdkColumnDef } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { AppCommonModule } from '../../../../app-common.module';
import { SupplyChainDirectBuyerAccountModule } from '../supply-chain-direct-buyer-account.module';
import { SupplyChainDirectCommonModule } from '../../supply-chain-direct-common.module';
import { BuyerInsightsEarlyPayAdoptionComponent } from './insights/early-pay-adoption.component';
import { BuyerInsightsComponent } from './insights/insights.component';
import { BuyerInsightsSpendVolumeComponent } from './insights/spend-volume.component';
import { BuyerInsightsSupplierEnrollmentComponent } from './insights/supplier-enrollment.component';
import { BuyerInsightsWorkingCapitalLiftComponent } from './insights/working-capital-lift.component';
import { AccountPaymentDetailComponent } from '../payment-details/payment-detail.component';
import { SupplyChainDirectBuyerRoutingModule } from './supply-chain-direct-buyer-routing.module';
import { SupplyChainDirectBuyerComponent } from './supply-chain-direct-buyer.component';
import { BuyerInvoiceUploadModalComponent } from './upload/buyer-upload-modal/buyer-invoice-upload-modal.component';
import { BuyerRemittanceInstructionsUploadModalComponent } from './upload/buyer-upload-modal/buyer-remittance-upload-modal.component';
import { BuyerRoutingInstructionsUploadModalComponent } from './upload/buyer-upload-modal/buyer-routing-instruction-upload-modal.component';
import { BuyerSupplierUploadModalComponent } from './upload/buyer-upload-modal/buyer-supplier-upload-modal.component';
import { BuyerUploadButtonComponent } from './upload/buyer-upload-modal/buyer-upload-button.component';
import { BuyerUploadModalComponent } from './upload/buyer-upload-modal/buyer-upload-modal.component';
import { BuyerInvoiceUploadSuccessModalComponent } from './upload/buyer-upload-modal/buyer-upload-success-modal/buyer-invoice-upload-success-modal.component';
import { BuyerRemittanceInstructionsUploadSuccessModalComponent } from './upload/buyer-upload-modal/buyer-upload-success-modal/buyer-remittance-instructions-upload-success-modal.component';
import { BuyerRoutingInstructionsUploadSuccessModalComponent } from './upload/buyer-upload-modal/buyer-upload-success-modal/buyer-routing-instructions-upload-success-modal.component';
import { BuyerSupplierUploadSuccessModalComponent } from './upload/buyer-upload-modal/buyer-upload-success-modal/buyer-supplier-upload-success-modal.component';
import { BuyerUploadSuccessModalComponent } from './upload/buyer-upload-modal/buyer-upload-success-modal/buyer-upload-success-modal.component';
import { BuyerInsightsAgingForecastComponent } from './insights/aging-forecast.component';

@NgModule({
    imports: [
        LsqCommonModule.forChild(),
        LsqTablesModule.forRoot(),
        AppCommonModule,
        SupplyChainDirectCommonModule,
        SupplyChainDirectBuyerRoutingModule,
        SupplyChainDirectBuyerAccountModule
    ],
    declarations: [
        SupplyChainDirectBuyerComponent,
        BuyerInsightsComponent,
        BuyerInsightsWorkingCapitalLiftComponent,
        BuyerInsightsSpendVolumeComponent,
        BuyerInsightsEarlyPayAdoptionComponent,
        BuyerInsightsSupplierEnrollmentComponent,
        BuyerInsightsAgingForecastComponent,
        BuyerUploadButtonComponent,
        BuyerUploadModalComponent,
        BuyerInvoiceUploadModalComponent,
        BuyerSupplierUploadModalComponent,
        BuyerRemittanceInstructionsUploadModalComponent,
        BuyerRoutingInstructionsUploadModalComponent,
        BuyerUploadSuccessModalComponent,
        BuyerInvoiceUploadSuccessModalComponent,
        BuyerSupplierUploadSuccessModalComponent,
        BuyerRemittanceInstructionsUploadSuccessModalComponent,
        BuyerRoutingInstructionsUploadSuccessModalComponent,
        AccountPaymentDetailComponent
    ],
    providers: [CdkColumnDef]
})
export class SupplyChainDirectBuyerModule {}
